
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
  import CarNumber from "@/components/CarNumber.vue";
  import {AntiTheftActions} from "@/modules/CarList/mixins/anti-theft-actions.mixin";
  import {IHome} from "@/modules/Home/interfaces/home.interface";
  import {bus} from "@/plugins/bus";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {ICar} from "@/modules/Car/interfaces/car.interface";

  @Component({
    components: {
      CarNumber,
    },
  })
  export default class ShortCarSecurity extends Vue {
    @Prop() car: IAntiTheft.IStatusCars;
    @Prop() smallSize: boolean;
    @Prop() secondaryPopup: boolean;
    @Prop() homePage!: boolean;

    carPopupTabs = ICar.CarPopupTab;

    async toggleStatus(value, car: IAntiTheft.IStatusCars) {
      car.theftFlag = !car.theftFlag;
      await AntiTheftActions.changeStatus(this, {
        carId: car.carId,
        securityActive: car.theftFlag,
        scheduleActive: car.theftScheduleFlag,
      });

      this.$notify({
        title: car.theftFlag ? 'Поставлен на охрану' : 'Снят с охраны',
        message: 'Вы можете задать расписание в карточке автомобиля.',
        type: 'success'
      });
    }

    async openCarPopup(car: IAntiTheft.IStatusCars, tabForOpen: ICarPopupTables.CarPopupTab) {
      let payload: ICarStore.IPopupPayload = {
        carId: car.carId,
        tabForOpen,
      };
      if (this.homePage) {
        payload.closeAction = async () => {
          bus.$emit(IHome.EmitterEvents.UpdateCarInfo);
        };
      }
      await this.$store.dispatch('car/openCarPopup', payload);
      this.$emit('openCarPopup');
    }
  }
